<template>
  <v-container grid-list-sm class="DisplaySubMenu">

    <div v-if="ef_loading"  style="z-index: 99999999 !important;position: fixed; top: 0; left: 0;background-color: #ffffff;width: 100%;height: 100%;">
      <br>
      <br>
      <br>
      <h1 class="justify-self-center"><v-progress-circular
          class="mr-1"
          indeterminate
          color="primary"
      ></v-progress-circular> Loading...</h1>
    </div>

    <v-layout row wrap align-start justify-start fill-height class="mt-3">
        <div v-if="menu && menu.length" class="my-2 primary--text d-flex align-center">
          <v-icon @click="gotoRoute(menu[0].menu_parent_uri_link, {external_link:1}, {
              nextFn: [
                {
                  fnName: 'clickSaved',
                  data: {
                    menu_id: menu[0].menu_parent
                  }
                }
              ]
            })" class="display-1 primary--text mr-3 grey lighten-3">mdi-chevron-left</v-icon>
          <h1 v-html="menu[0].menu_parent_name"> </h1>
        </div>
        <template v-for="(item) in menu">
        <v-flex class="align-start each_menu my-1 pa-0 text-xs-center" @click="redirect_page(item)" style="width: 100%">
          <div class="primary darken-1 pa-1 sub_menu">
              <div>
                <v-img v-if="item.menu_icon_img " :src="(item.menu_icon_img_type == 'url' ? item.menu_icon_img:require('@/assets/img/'+item.menu_icon_img))">
                    <v-icon v-if="item.menu_icon" :class="item.menu_icon_class">
                        {{ item.menu_icon }}
                    </v-icon>
                </v-img>
                <v-icon v-else-if="item.menu_icon" :class="item.menu_icon_class">
                    {{ item.menu_icon }}
                </v-icon>
              </div>
              <div class="white--text">{{ item.menu_name }}</div>
          </div>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import EventBus from "@/EventBus";
import axios from "@/axios";
import base64 from "base-64";
export default {
  name: "DisplaySubMenu2",
  data() {
    return {
      userId: '',
      menu: null,

      menu_access: null,
      MenuId: '',
      ef_loading: false,
    }
  },
  mounted() {
    EventBus.$emit('set_navigation', {title: 'Service Excellence'})
    let localitem = this.getLocalItem()
    if (localitem && localitem.user_id) {
      this.userId = localitem.user_id

    }

    if( (this.$route.query.MenuId) && (this.$route.query.hasOwnProperty('MenuId')) ){
      this.MenuId = this.$route.query.MenuId;
      this.getSubMenu();
    }

  },
  methods: {

    async getSubMenu(){
      try {
        const uri = '/getSubMenu?menuId='+this.MenuId
        const res = await axios.get(uri)
        if (res){
          //Check user can access menu
          let menu_can_access = []
          const menuPromise = [...res.data.result].map(async m => {
            let can_access = true;

            if(m.menu_code){
              can_access =  await this.checkPermission(m.menu_code,'CAN_ACCESS')
            }

            if(can_access){
              menu_can_access.push(m)
            }
          })

          await Promise.all(menuPromise)

          this.menu  = [...menu_can_access]
        }
      } catch (err) {
        console.log(err.message)
      }
    },
    async redirect_page(menu_prop) {
      // console.log(menu_prop)
      let menu_redirect = menu_prop.menu_route_name
      let params = {}

      if (!menu_prop.menu_route_name) {
        if(menu_prop.menu_uri_link) {
          let user_id = this.userId
          if (menu_prop.menu_uri_link.indexOf('<userId>') !== -1) {
            menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<userId>', user_id)
          }

          if (menu_prop.menu_uri_link.indexOf('<userId64>') !== -1) {
            menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<userId64>', base64.encode(user_id))
          }

          if (menu_prop.menu_uri_link.indexOf('<TokenAuthApi>') !== -1) {
            this.ef_loading = true;
            let TokenData = await this.GetTokenLoginSystem(user_id,menu_prop.skd01,menu_prop.skd02);
            this.ef_loading = false;

            if(!TokenData){
              alert('Authentication failed');
              return false;
            }

            menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<TokenAuthApi>', TokenData);

          }

          if (menu_prop.menu_uri_link.indexOf('<TokenAuthApiV2>') !== -1) {
            this.ef_loading = true;
            let TokenData = await this.GetTokenLoginSystem(user_id,menu_prop.skd01,menu_prop.skd02);
            this.ef_loading = false;

            if(!TokenData){
              alert('Authentication failed');
              if(menu_prop.url_login_error && menu_prop.url_login_error != ''){
                window.location=menu_prop.url_login_error;
              }
              return false;
            }

            //ไปที่ url เลย กด back ไม่ได้
            window.location.replace(menu_prop.menu_uri_link.replace('<TokenAuthApiV2>', TokenData));
            return false;

          }

          if (menu_prop.menu_uri_link.indexOf('<LPPTokenAuthApiV2>') !== -1) {
            this.ef_loading = true;
            let TokenData = await this.GetTokenLoginLPPSystem(user_id);

            this.ef_loading = false;

            if(!TokenData){
              alert('Authentication failed');
              if(menu_prop.url_login_error && menu_prop.url_login_error != ''){
                window.location=menu_prop.url_login_error;
              }
              return false;
            }

            //ไปที่ url เลย กด back ไม่ได้
            window.location.replace(menu_prop.menu_uri_link.replace('<LPPTokenAuthApiV2>', TokenData));
            return false;

          }

          if (menu_prop.menu_uri_link.indexOf('<jwt>') !== -1) {
              const jwt_obj  = localStorage.getItem('svea_emp') ? JSON.parse(localStorage.getItem('svea_emp')): null
              if(jwt_obj){
                  menu_prop.menu_uri_link = menu_prop.menu_uri_link.replace('<jwt>',jwt_obj.token)
              }else{
                  menu_prop.menu_uri_link = "";
              }
          }
          params.external_link = 1
          menu_redirect = menu_prop.menu_uri_link
        } else {
          alert('พบกันเร็วๆ นี่')
        }
      }

      this.gotoRoute(menu_redirect, params, {
        nextFn: [
          {
            fnName: 'clickSaved',
            data: {
              menu_id: menu_prop.menu_id
            }
          }
        ]
      });

    }



  }
}
</script>

<style scoped>
  .sub_menu{
      cursor: pointer;
      border-radius: 5px;
  }
  .sub_menu:hover{
      background-color: #024d93 !important;
  }
  .DisplaySubMenu{
      max-width: 450px;
  }
</style>
